import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { RpmStatusTriangle } from '../../../../../../../../assets/Logos/Icons'
import { BloodPressureicon } from '../../../../../../../../assets/Logos/Icons'
import videoplay from '../../../../../../../../assets/RpmAssets/videoplay.png'
import { Chart } from "react-google-charts";
import moment from 'moment';
//import heartBeatImage from '../../../../../../../../assets/RpmAssets/PNGIcons/BloodPressure.svg'


function BloodPressure() {
    let reduxData = useSelector(state => state) ; 
    console.log("Redux Data in RpmProfile: ",reduxData);
    let patientDetails = reduxData.rpmreducer.vitalhistory && 
                            reduxData.rpmreducer.vitalhistory.data.bloodpresure;
    
    
    console.log(patientDetails)


    const data = [
              ["Date", "Reading"],
              ["Jan 2022", 0,],
              ["Feb 2022", 50],
              ["Mar 2022", 0],
              ["Apr 2022", 50],
              ["May 2022", 0,],
              ["Jun 2022", 50],
              ["Jul 2022", 0],
              ["Aug 2022", 60],
              ["Sep 2022", 0],
              ["Oct 2022", 20],
          ];
        
          const options = {
              title: "",
              //curveType: "function",
              legend: { position: "none" },
             // hAxis: { textPosition: 'none' },
             // vAxis: { textPosition: 'none' },
              colors: ["#20C4C7","#000"],
              width: "100%",
              lineWidth: 3,
              chartArea: { width: "80%", height: "80%" },
          };
          const convertToGraphData = () => {

            let data = []
    
            if (patientDetails && patientDetails.length > 0) {
    
                data.push(["Date", "Systolic", "Diastolic",],)
                patientDetails.forEach(element => {
                    //13/12/2022 05:24:21 PM
                    console.log("moment",moment(element.date,'DD/MM/YYYY h:mm:ss A').format("MMM YYYY"));
                    data.push( [moment(element.date,'DD/MM/YYYY h:mm:ss A').format("DD-MMM"), Number(element.systolic),Number(element.diastolic)],)
    
                });
            }
    
            console.log(data);
    
            return data
    
    
    
        }

    return (
        <div className='blood-pressure-vital-container'>

            <div className="blood-pressure-vital-container_details">
            {patientDetails!=undefined && patientDetails.length>0?(
                <ul className='patient-vitals-list'>
                    {
                        patientDetails.map((element,key) => {
                            return (
                                <li className={key===0&&'patient-vitals-list_active'} key={key}>


                                    <div className="left">
                                        
                                        <BloodPressureicon/>
                                        <span className='item'>BP</span>

                                        {/* <div className="icon">
                                            <RpmStatusTriangle variant="abnormal" size="13" />
                                        </div> */}
                                        <span className='value'>{element.systolic+"/"+element.diastolic}</span>
                                        <span className='unit'>mmHg</span>

                                        {/* <div className="icon">
                                            <RpmStatusTriangle variant="critical" size="13" />
                                        </div> */}

                                       
                                    </div>

                                    <div className="left">


                                        <span className='value'>{element.pulserate}</span>
                                        <span className='unit'>bpm</span>
                                    </div>
                                    <div className="left">
                                        {element.blood_pressurevideo!=''&&
                                                <a href={element.blood_pressurevideo} target="_blank">  <img src={videoplay} alt="" /></a>
                                            }
                                    </div> 

                                    <div className="left">

                                        <span className='unit'>as on {element.date}</span>
                                    </div>
                                </li>
                            )
                        })
                    }
                </ul>
                ):"No Data Available"}
            </div>
        
        {/* { patientDetails.length>=3?(
           <div className="blood-pressure-vital-container_graph">

                <span className="title">Last 10 readings</span>

                <div className="dummy-graph">
                    <Chart
                        chartType="LineChart"
                        width="100%"
                        height="100%"
                        data={convertToGraphData()}
                        options={options}
                    />
                </div>

                </div> 
        ):""
    }  */}

        </div>
    )
}

export default BloodPressure